<template>
  <div :class="['flex flex-col w-full px-4 pb-4', wrapperClass]">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TabContent',

  props: {
    tab: {
      type: Object,
      required: true,
    },

    wrapperClass: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {}
  },
})
</script>
